import { ComponentDescriptor } from '../../../../../components/PageBuilder';

interface Mapping {
  [legacyName: string]: string | ComponentDescriptor;
}

export const componentsMapping: Mapping = {
  AccountHolder: 'AccountHolder', // create
  TermsEnergy: 'TermsList', // find or create
  TermsTriplePlay: 'TermsList',
  Info: 'Info', // find or create
  FirstName: 'FirstName', // find or create
  LastName: 'LastName', // find or create
  AddressDisplay: 'AddressDisplay', // find or create
  AddressBirthdateDisplay: 'AddressBirthdateDisplay', // find or create
  LicencePlateDisplay: 'LicencePlateDisplay', // to be checked
  Initials: { type: 'Field', props: { type: 'Initials' } }, // to be checked
  CarSecurityClassDisplay: 'CarSecurityClassDisplay', // to be checked
  MembershipCbUsp: { type: 'Field', props: { type: 'CbMembership' } },
  BannerHtmlBody: { type: 'Field', props: { type: 'Banner' } },
  MembershipWarning: 'MembershipWarning',
  heading: {
    type: 'WizardHeading',
    props: { valueAsChildren: true, my: 4 },
  },
};

export default componentsMapping;
